<template>
  <div class="container">
    <HMModalHeader
      :title="
        chatRoom.id
          ? $t('COMMUNITY.TITLE.EDIT_CHAT_ROOM')
          : $t('COMMUNITY.TITLE.CREATE_NEW_CHAT_ROOM')
      "
      @close="onDiscard"
    />
    <div ref="wrapper" class="community-chat-users-container w-100">
      <label>{{ $t('COMMUNITY.TEXT.ADD_MEMBERS_TO_THE_ROOM') }}</label>
      <v-select
        :disabled="chatRoom.is_private"
        @search="searchUsers"
        v-model="chatRoom.members"
        :options="users"
        label="full_name"
        code="id"
        :reduce="member => member"
        :placeholder="$t('COMMUNITY.TEXT.SEARCH_TO_ADD_MEMBERS_TO_THE_ROOM')"
        multiple
        class="users-selector mb-4"
      >
        <template v-slot:option="option">
          <div class="d-flex">
            <div v-if="option.image">
              <HMPhotoIcon
                :instructor="{ image: option.image }"
                size="24px"
                class="mr-2"
              />
            </div>
            <div v-else>
              <HMPhotoIcon
                :instructor="{ image: '/assets/images/avatar.svg' }"
                size="24px"
                class="mr-2"
              />
            </div>
            {{ option.label }}
          </div>
        </template>
      </v-select>
      <HMTextInput
        :label="$t('COMMUNITY.LABEL.CHAT_ROOM_NAME')"
        v-model="chatRoom.room_name"
      />
      <HMS3ImageUploader
        photoType="profile"
        inputName="community-room-chat-icon"
        :title="$t('COMMUNITY.LABEL.UPLOAD_CHAT_ROOM_PHOTO')"
        :description="$t('COMMUNITY.TEXT.UPLOAD_CHAT_ROOM_PHOTO')"
        :imageDescription="$t('COMMUNITY.LABEL.UPLOAD_CHAT_ROOM_PHOTO')"
        v-model="chatRoom.image"
        :canvaWidth="300"
        :canvaHeight="300"
        class="mb-4"
        :round="true"
      />
    </div>
    <form @submit.prevent="onConfirm">
      <HMModalFooter
        :submitButton="
          chatRoom.id ? $t('GENERAL.BUTTON.SAVE') : $t('GENERAL.BUTTON.CREATE')
        "
        :discardButton="$t('GENERAL.BUTTON.CLOSE')"
        @close="onDiscard"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import _ from 'lodash';

export default Vue.extend({
  name: 'CommunityChatRoomModal',
  props: {
    chatRoom: {
      type: Object,
      default: () => {
        return {
          room_name: null,
          members: [],
        };
      },
    },
    confirm: null,
  },
  data() {
    return {
      users: [],
    };
  },
  methods: {
    searchUsers: _.throttle(async function (query) {
      try {
        if (!query || query.length < 1) {
          this.users = [];
          return;
        }
        let foundUsers = await this.$store.dispatch('community/searchUsers', {
          studioURL: getStudioURL(this.$route),
          query,
        });

        const addedMembersIds =
          this.chatRoom?.members?.map(member => member.id) || [];
        foundUsers = foundUsers.filter(
          user => !addedMembersIds.includes(user.id)
        );

        this.users = foundUsers.map(user => {
          return {
            ...user,
            label: user.full_name,
          };
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error.response),
          duration: -1,
        });
      }
    }, 500),
    async onConfirm() {
      this.confirm(this.chatRoom);
      this.$emit('close');
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      this.$emit('close');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.v-select {
  .vs__dropdown-menu {
    z-index: 2;
    position: relative;
  }
}

.community-chat-users-container {
  min-height: 300px;
  max-width: 550px;
}

.community-chat-user-table {
  overflow-y: auto;
  //max-height: 300px;
}
</style>
